import { useQuery } from "react-query";
import {
  getPlatformCreditInfo,
  getPlatformCreditTransactions,
  getSenderList,
} from "../../../services/platformCredit";

export const useGetPlatformCreditTransactions = ({
  queries = "",
  queryParams = {},
}) => {
  return useQuery(
    ["getPlatformCreditTransactions", queries, queryParams],
    () =>
      getPlatformCreditTransactions(queries, queryParams).then(
        (res) => res.data,
      ),
    { staleTime: Infinity },
  );
};

export const useGetPlatformCreditInfo = () => {
  return useQuery(
    ["getPlatformCreditInfo"],
    () => getPlatformCreditInfo().then((res) => res?.data?.data),
    { staleTime: Infinity },
  );
};
export const useGetSenderList = () => {
  return useQuery(
    ["getSenderList"],
    () => getSenderList().then((res) => res?.data),
    { staleTime: Infinity },
  );
};
